import { Persona } from "../../domain/entities/persona";
import { Prestacion } from "../../domain/entities/prestacion";
import { PrestacionReferencia } from "../../domain/entities/prestacionReferencia";
import { PrestacionPreparacion } from "../../domain/entities/prestaciónPreparación";
import { Protocolo } from "../../domain/entities/protocolo";
import { ProtocoloDetalle } from "../../domain/entities/ProtocoloDetalle";
import { ProtocoloApi } from "../../domain/interfaces/protocoloApi";
import { PrestacionHistorico } from "../../domain/entities/prestacionHistorico";

export class ApiImplementation implements ProtocoloApi {
  async getPrestacionHistorico(
    ordenDeTrabajo: number,
    token: string
  ): Promise<PrestacionHistorico[]> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL + `/protocolo/${ordenDeTrabajo}/history`,
        {
          headers,
          method: "GET",
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      const data = await response.json();
      //console.log("historico api:", data.data[0].resultado);
      //Cuando llega la respuesta, actualiza el token en el navegador
      //console.log("acces_token", data.access_token);
      localStorage.setItem("token", data.access_token);
      // Mapeo de los datos recibidos a instancias de Prestacion
      const colPrestacionHistoricos: PrestacionHistorico[] =
        PrestacionHistorico.fromCollection(data.data[0].resultado || []);

      return colPrestacionHistoricos;
    } catch (error) {
      console.error("Error al obtener detalles del protocolo:", error);
      throw error; // Propaga el error para que el llamador lo maneje
    }
  }
  async getPersona(token: string): Promise<Persona> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL + `/paciente`,
        {
          headers,
          method: "GET",
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      const data = await response.json();
      //Cuando llega la respuesta, actualiza el token en el navegador
      //localStorage.setItem("token", data.access_token);
      // Mapeo de los datos recibidos a instancias de Prestacion
      const persona: Persona = Persona.fromCollection(data);

      return persona;
    } catch (error) {
      console.error("Error al obtener detalles del protocolo:", error);
      throw error; // Propaga el error para que el llamador lo maneje
    }
  }
  async getPrestacionPreparacion(
    idPrestación: number,
    token: string
  ): Promise<PrestacionPreparacion[]> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL +
          `/prestacion/preparacion/${idPrestación}`,
        {
          headers,
          method: "GET",
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      // Mapeo de los datos recibidos a instancias de Prestacion
      const colPrestacionPreparacion: PrestacionPreparacion[] =
        PrestacionPreparacion.fromCollection(data.data);

      return colPrestacionPreparacion;
    } catch (error) {
      console.error("Error al obtener detalles del protocolo:", error);
      throw error; // Propaga el error para que el llamador lo maneje
    }
  }
  async getPrestacionReferencia(
    idPrestación: number,
    token: string
  ): Promise<PrestacionReferencia[]> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL +
          `/prestacion/referencia/${idPrestación}`,
        {
          headers,
          method: "GET",
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      // Mapeo de los datos recibidos a instancias de Prestacion
      const colPrestacionReferencia: PrestacionReferencia[] =
        PrestacionReferencia.fromCollection(data.data);

      return colPrestacionReferencia;
    } catch (error) {
      console.error("Error al obtener detalles del protocolo:", error);
      throw error; // Propaga el error para que el llamador lo maneje
    }
  }
  async getPrestaciones(token: string): Promise<Prestacion[]> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL + `/prestacion`,
        {
          headers,
          method: "GET",
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      // Mapeo de los datos recibidos a instancias de Prestacion
      const colPrestaciones: Prestacion[] = Prestacion.fromCollection(
        data.data
      );

      return colPrestaciones;
    } catch (error) {
      console.error("Error al obtener detalles del protocolo:", error);
      throw error; // Propaga el error para que el llamador lo maneje
    }
  }

  async getProtocolos(
    startDate: string,
    endDate: string,
    token: string
  ): Promise<Protocolo[]> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL + `/protocolo`,
        {
          headers,
          method: "POST",
          body: JSON.stringify({
            startDate: startDate,
            endDate: endDate,
          }),
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      // Mapeamos los datos de la API a la clase Protocolo
      const protocolos: Protocolo[] = Protocolo.fromCollection(data.data);

      return protocolos;
    } catch (error) {
      console.error("Error al obtener protocolos:", error);
      throw error;
    }
  }

  async getProtocoloDetalle(
    ordenDeTrabajo: number,
    token: string
  ): Promise<ProtocoloDetalle[]> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL + `/protocolo/${ordenDeTrabajo}/details`,
        {
          headers,
          method: "GET",
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      // Mapeo de los datos recibidos a instancias de ProtocoloDetalle
      const protocoloDetalles: ProtocoloDetalle[] =
        ProtocoloDetalle.fromCollection(data.data);

      return protocoloDetalles;
    } catch (error) {
      console.error("Error al obtener detalles del protocolo:", error);
      throw error; // Propaga el error para que el llamador lo maneje
    }
  }

  async getProtocoloInforme(
    ordenDeTrabajo: number,
    token: string
  ): Promise<string> {
    try {
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
      };

      if (process.env.REACT_APP_USE_NGROK === 'true') {
        headers['ngrok-skip-browser-warning'] = 'true';
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL + `/protocolo/${ordenDeTrabajo}/informe`,
        {
          headers,
          method: "GET",
        }
      );

      // Verificación de respuesta no exitosa
      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("No autorizado. Verifica el token.");
        }
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }

      // Obtener el contenido HTML como texto
      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      return data.informe; // Devolver el string con el contenido HTML
    } catch (error) {
      console.error(`Error al obtener el informe del protocolo:`, error);
      throw new Error("Error en el servidor o al procesar la solicitud.");
    }
  }
}
